import Form from './Form';
import { useTranslation } from 'react-i18next';
import NavigationMenuDialog from '../NavigationMenu/Dialog';
import { Stack } from '@mui/material';
import { useDocumentContext } from '../DocumentContext';

export default function Dialog({
  open,
  onClose,
}: Readonly<{
  open: boolean;
  onClose: () => void;
}>) {
  const { t } = useTranslation();
  const { productMeta } = useDocumentContext();

  if (!productMeta?.pageNumbers) {
    return null;
  }

  return (
    <NavigationMenuDialog
      open={open}
      onClose={onClose}
      title={t('readingView.navigation.page.title')}
      closeLabel={t('readingView.navigation.page.close')}
    >
      <Stack sx={{ paddingTop: 4, paddingX: 2, paddingBottom: 4 }}>
        <Form lastPageNumber={productMeta.pageNumbers.last} onClose={onClose} />
      </Stack>
    </NavigationMenuDialog>
  );
}
